var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ban-form',{attrs:{"title":"Add Ban","ban":_vm.ban},on:{"addban":_vm.addBan}})}
var staticRenderFns = []

export { render, staticRenderFns }